import PropTypes from 'prop-types';

import useAccountQuery from 'api/queries/useAccountQuery';
import useSelectionsQuery from 'api/queries/useSelectionsQuery';
import Tag from 'honeydew/Tag/Tag';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';
import { getCartMemberSavings, getCartNonMemberSavings } from 'utils/priceUtils';

function PlusMembershipMemberBanner() {
    const { data: account = {} } = useAccountQuery();
    const { data: selections = {} } = useSelectionsQuery();

    const { plusMembershipBranding, plusMembershipEligibleOrder, plusMembershipShortBranding } =
        useAccountPlusMembershipHook();

    const cartNonMemberSavings = getCartNonMemberSavings({ account, selections });
    const cartMemberSavings = getCartMemberSavings({ account, selections });

    const cartTotalSavings = cartNonMemberSavings + cartMemberSavings;

    if ((cartNonMemberSavings > 0 && cartMemberSavings <= 0) || !plusMembershipEligibleOrder) {
        return null;
    }

    return (
        <div className="relative mt-10 flex w-full justify-center overflow-hidden rounded-lg bg-malt p-5 pt-10 if:bg-oat">
            <div className="absolute left-0 top-0 z-10 h-5 w-full bg-gradient-berry-blend" />
            <div className="flex items-center justify-center gap-10">
                <p className="text-body-sm w-fit text-center">
                    {cartMemberSavings > 0 && (
                        <>
                            <span className="block font-grotesk-bold">
                                You saved <span className="text-cranberry">${cartTotalSavings.toFixed(2)}</span> on this
                                order
                            </span>
                            ${cartMemberSavings.toFixed(2)} is from your{' '}
                            <Tag bgColor="cranberry" fontSize="mobileXS" variant="dark">
                                {plusMembershipShortBranding}
                            </Tag>{' '}
                            membership
                        </>
                    )}
                    {cartNonMemberSavings <= 0 && cartMemberSavings <= 0 && (
                        <span className="font-grotesk-bold">
                            Thanks for being a <span className="text-cranberry">{plusMembershipBranding}</span> member!
                        </span>
                    )}
                </p>
            </div>
        </div>
    );
}

PlusMembershipMemberBanner.propTypes = {
    intersectionRef: PropTypes.shape({}).isRequired,
};

export { PlusMembershipMemberBanner };
